const initialState = {
  toggle_header: false,
  layoutstyledata: "horizontal",
  menu_focus: {},
  context_company: [],
  fields: {}
};

export default initialState;
